import React from "react";
import { ModeRendererProps } from "./types";

export function AgamBarsMode({ brand }: ModeRendererProps) {
  return (
    <g>
      <g clipPath="url(#circleClip)">
        {Array.from({ length: 44 }).map((_, i) => {
          const x = 80 + i * 14;
          const yoff = i % 2 === 0 ? -20 : 20;
          return <rect key={i} x={x - 320} y={220 + yoff} width="12" height="640" fill="url(#spectrum)" />;
        })}
      </g>
      <g transform="translate(397 540)">
        {Array.from({ length: 10 }).map((_, i) => (
          <circle
            key={i}
            r={90 + i * 22}
            fill="none"
            stroke={i % 3 === 0 ? brand.aqua : i % 3 === 1 ? brand.violet : brand.amber}
            strokeOpacity="0.6"
          />
        ))}
        <circle r="310" fill="none" stroke={brand.white} strokeWidth="2" opacity="0.8" />
      </g>
    </g>
  );
}
